import { ListPage, EditPage, AddNewPage } from "./pages";

export function DevicePage() {
  return <></>;
}

DevicePage.List = ListPage;
DevicePage.AddNew = AddNewPage;
DevicePage.Edit = EditPage;
